import React, { useState } from 'react';
import OverlayLoading from '../Components/OverlayLoading';

const withOverlayLoading = (Component: React.FC<any>) => {
	return (props: any) => {
		const [loading, setLoading] = useState<boolean>(false);

		return (
			<div style={{ position: 'relative' }}>
				<Component setLoading={setLoading} {...props} />
				{loading && <OverlayLoading />}
			</div>
		);
	};
};

export default withOverlayLoading;
